import { Type, type Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  BooleanField,
  TextField,
  SlugField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Справочник типов разнесения документов.
 *
 * Определяет, как документ участвует в распределении расходов:
 * по сделкам, на общие расходы, неразобранные (требуют ручной обработки)
 * или исключённые (не участвуют в отчётах).
 */
export const AccountingAllocationTypeSchema = Type.Object({
  ...SystemFields,

  code: SlugField({
    title: 'Код типа разнесения',
    description: 'Уникальный код типа (DEAL, COMPANY, UNALLOCATED, EXCLUDED).',
    unique: true,
  }),

  name: StringField({
    title: 'Название',
    minLength: 1,
    maxLength: 255,
    description: 'Название, отображаемое пользователю.',
  }),

  is_active: BooleanField({
    title: 'Активен',
    default: true,
    description: 'Неактивные типы скрываются при выборе.',
  }),

  description: TextField({
    title: 'Описание',
    nullable: true,
    description: 'Дополнительные комментарии о назначении типа.',
  }),
});

export type AccountingAllocationType = Static<typeof AccountingAllocationTypeSchema>;

export default defineSchema({
  moduleName,
  tableName: 'allocation_types',
  schema: AccountingAllocationTypeSchema,
  additionalIndexes: [{ columns: ['code'], unique: true }, 'is_active'],
});
